<!--
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-07-22 17:11:59
 * @LastEditors: xiaona.wang
 * @LastEditTime: 2021-08-06 19:27:54
-->
<template>
  <div class="self-tabs">
    <div
      v-for="tab in propsData"
      :key="tab.name"
      class="tab"
      :class="{ activeTab: tab.name === activeName }"
      @click="handleTabClick(tab)"
    >
      {{ tab.label }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Tabs",

  props: {
    propsData: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      activeName: ""
    };
  },

  watch: {
    value(value) {
      this.setCurrentName(value);
    }
  },

  mounted() {
    if (this.propsData.length) {
      this.activeName = this.value || this.propsData[0].name;
    }
  },

  methods: {
    handleTabClick(tab) {
      this.$emit("update:value", tab.name);
      this.setCurrentName(tab.name);
      this.$emit("tab-click", tab);
    },
    setCurrentName(value) {
      this.activeName = value;
    }
  }
};
</script>

<style scoped lang="scss">
.self-tabs {
  height: 30px;
  display: flex;
  margin: 16px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  .tab {
    padding: 0 26px;
    color: #21252e;
    cursor: pointer;
    margin-right: 34px;
  }
  .activeTab {
    color: #00b259;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    position: relative;
    &:after {
      content: "";
      position: absolute;
      left: 0;
      bottom: -2px;
      width: 100%;
      height: 3px;
      background: #00b259;
    }
  }
}
</style>
